var _rect, _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomingVehicleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 17,
    rx: 0.5,
    fill: "#FCC214",
    fillOpacity: 0.1,
    stroke: "#FCC214"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4677 5.80078H21H20.5V17.5615H21.9783H28.2837H28.5C29.0523 17.5615 29.5 17.1138 29.5 16.5615V11.3052C29.5 11.1063 29.4407 10.9118 29.3295 10.7468L26.2973 6.24235C26.1114 5.96631 25.8005 5.80078 25.4677 5.80078Z",
    fill: "#FCC214",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.366H21.5M20.2913 17.5615H20.5M20.5 17.5615H21.9783H28.2837H28.5C29.0523 17.5615 29.5 17.1138 29.5 16.5615V11.3052C29.5 11.1063 29.4407 10.9118 29.3295 10.7468L26.2973 6.24235C26.1114 5.96631 25.8005 5.80078 25.4677 5.80078H21H20.5V17.5615Z",
    stroke: "#FCC214",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.2V10.8C22.5 10.9105 22.5895 11 22.7 11H26.6263C26.786 11 26.8813 10.822 26.7927 10.6891L25.0594 8.08906C25.0223 8.03342 24.9598 8 24.893 8H22.7C22.5895 8 22.5 8.08954 22.5 8.2Z",
    fill: "white",
    stroke: "#FCC214",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 2.5,
    fill: "#FFF9E7",
    stroke: "#FCC214"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 18,
    r: 2.5,
    fill: "#FFF9E7",
    stroke: "#FCC214"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5001,
    cy: 8.50011,
    r: 4.71739,
    fill: "#FCC214",
    stroke: "#FFF9E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.86865L12.1304 8.66213L10.5 10.4556",
    stroke: "#FFF9E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32617 8.71631H11.9131",
    stroke: "#FFF9E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingVehicleIcon);
export default __webpack_public_path__ + "static/media/incomingVehicleIcon.d7df87cf7b8d50a0a732c67096bf261c.svg";
export { ForwardRef as ReactComponent };